var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"verify-email"},[_c('div',{staticClass:"supplemental flex-row"},[_c('alert-icon'),_vm._v(" Not verified")],1),_c('a',{on:{"click":_vm.resendVerifyEmail}},[_vm._v("Resend verification email")])])}
var staticRenderFns = []

export { render, staticRenderFns }